<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">學生緊急傷病處理報告表</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-date-input v-model="vm.Date" id="Date" label="日期" required></form-date-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Time" id="Time" label="時間(24小時制)" type="time" required></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-select v-model="vm.Place" id="Place" label="發生地點" required>
                    <slot name="place"></slot>
                </form-select>
            </div>
            <div class="col-md-4 col-sm-12">
                <label>學號</label>
                <input v-model="vm.StudentNo" id="StudentNo" type="text" class="form-control" @change="studentNoChange" required />
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.StudentName" id="StudentName" label="姓名" type="text" disabled></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-select v-model="vm.ClassID" label="班級" required>
                    <div is="option" v-for="o in classList" :key="o.key" :value="o.key">{{o.value}}</div>
                </form-select>
            </div>
            <div class="col-12">
                <form-input v-model="vm.Students" id="Students" label="陪同學生(多名學生請用,隔開)" type="text" placeholder="請輸入學號"></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.TeacherNo" id="TeacherNo" label="陪同教師" placeholder="請輸入工號" type="text"></form-input>
            </div>
            <div class="col-12">
                <form-textarea v-model="vm.Process" id="Process" label="事情經過" type="text" required></form-textarea>
            </div>
            <div class="col-12">
                <form-textarea v-model="vm.Handle" id="Handle" label="處理情形" type="text"></form-textarea>
            </div>
            <div class="col-12">
                <form-textarea v-model="vm.Track" id="Track" label="追蹤個案傷病後情形" type="text"></form-textarea>
            </div>
            <div class="col-12">
                <form-textarea v-model="vm.Remark" id="Remark" label="備註" type="text"></form-textarea>
            </div>
            <div class="col-12">
                <form-date-input v-model="vm.Close" id="Close" label="結案日期"></form-date-input>
            </div>
            <div class="col-12">
                <form-date-input v-model="vm.Referrals" id="Referrals" label="(轉介學生輔導組)通知日期"></form-date-input>
            </div>
            <div class="col-12">
                <form-date-input v-model="vm.AddTrack" id="AddTrack" label="(列入個案管理追蹤)立案日期"></form-date-input>
            </div>
            <div class="col-12">
                <div class="alert alert-danger">
                    <h2>送醫費用申請</h2>
                    <ul style="list-style-type:upper-roman">
                        <li>車資費：以計程車費率計算，單次上限150元。</li>
                        <li>
                            護送就醫：
                            <ul style="list-style-type:lower-roman">
                                <li>護送人員於上班時間外給予補休。</li>
                                <li>車資及慰問品由護送人員代墊憑收據統一報銷。</li>
                            </ul>
                        </li>
                        <li>排除補助條款：學生傷病情形經調查後，凡有不假外出、無照駕駛、肇致傷病事故情形者或違反獎懲規定等行為，不予補助「學生緊急傷病送醫費用｣。</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Car" id="Car" label="使用車輛">
                    <div is="option" value=""></div>
                    <div is="option" value="救護車">救護車</div>
                    <div is="option" value="計程車">計程車</div>
                    <div is="option" value="私車公用">私車公用</div>
                </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.Hospital" id="Hospital" label="送達醫院" type="text"></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.Fare" id="Fare" label="車資" type="number"></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.Condolences" id="Condolences" label="慰問品" type="number"></form-input>
            </div>
        </div>
        <!--<label class="form-control d-inline w-auto" slot="modal-footer">
            <input type="checkbox" v-model="vm.AddTrack" />建立個案追蹤
        </label>-->
    </modal>
</template>

<script>
    const now = new Date();
    const time = `${window.padLeft(now.getHours(), 2)}:${window.padLeft(now.getMinutes(), 2)}`;

    import { detail } from '@/views';
    export default detail({
        name: 'injuryhandleDetail',
        api: '/api/injuryhandle/',
        vm: { Date: now, Time: time },
        data: {
            classList: [],
        },
        created: function () {
            this.$parameter.class('', '', '', '', '').then((res) => { this.classList = res.data.Class });
        },
        methods: {
            studentNoChange: function () {
                this.$parameter.sclass(this.vm.StudentNo)
                    .then((res) => {
                        this.vm.StudentName = res.data.name;
                        this.$parameter.class('', '', '', '', res.data.classValue).then(x => this.classList = x.data.Class);
                    })
            },
        },
    });
</script>

<style>
</style>